import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromTap from 'app/state/tap';
import * as fromStatistics from 'app/state/statistics';

export const tapDetailResolverFn: ResolveFn<any> = (route, state) => {
  const store = inject(Store);
  const id = route.paramMap.get('id') ?? '';
  if (!id) return false;

  store.dispatch(fromTap.setItem({ id: id }));
  store.dispatch(fromStatistics.loadStatisticsForTap({ tapId: id, limit: 5 }));
  return true;
};
